import { qualityManagementHeaders } from 'lib/helpers/constants/columns/qualityManagementHeaders';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import TeamsTable from '../teams/teams-table/TeamsTable';
import Headline from 'components/atoms/headline/Headline';
import DashboardBoxLayout from 'components/templates/dashboard-box-layout/DashboardBoxLayout';
import DashboardBoxTitle from 'components/atoms/title/DashboardBoxTitle';
import IconButton from 'components/atoms/button/IconButton';
import Icon from 'components/atoms/icon/Icon';
import { IconType } from 'lib/helpers/constants/iconTypes';
import Input from 'components/atoms/input/Input';
import FilterBorderedWrapper from 'components/atoms/filter-bordered-wrapper/FilterBorderedWrapper';
import ConditionalRender from 'components/atoms/conditional-render/ConditionalRender';
import DynamicDropdown from 'components/molecules/dynamic-dropdown/DynamicDropdown';
import ConfigureTableDropdown from 'components/organisms/leads/dropdowns/ConfigureTableDropdown';
import NoDataBoundary from 'components/atoms/no-data-boundary/NoDataBoundary';
import EmptyEntity from 'components/atoms/empty-entity/EmptyEntity';
import { useQualityCheckQuestions } from 'lib/hooks/queries/Coustomer/useQualityCheckQuestions';
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen';
import CreateAndUpdateQuestions from './create-update-questions/CreateAndUpdateQuestions';


const QualityManagement = () => {
    const { t } = useTranslation();
    const [tableHeaders, setTableHeaders] = useState(qualityManagementHeaders);
    const [configureTableOpen, setConfigureTableOpen] = useState<boolean>(false);

    const [filterData, setFilterData] = useState<any>({
        search: "",
    });

    const {data, isLoading} = useQualityCheckQuestions(filterData);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
 
    return (
        <div>
            <Headline title="Quality Management" />
            <DashboardBoxLayout>
                <div className="flex gap-3 items-center justify-between mb-5">
                    <div className="flex-1">
                        <DashboardBoxTitle
                            title={t('Setup Questions')}
                        />
                    </div>
                    <IconButton
                        icon={<Icon color="#fff" iconType={IconType.PLUS_ICON} />}
                        onClick={() => {
                            setIsModalOpen(true);
                        }}
                    >
                        {t('New Question')}
                    </IconButton>
                </div>
                                <div className="flex gap-3 items-center mb-5 flex-wrap md:flex-nowrap justify-end">
                    <div className="flex-1 basis-full md:basis-auto">
                        <Input
                            icon={IconType.SEARCH_ICON}
                            className=" border-0 !border-[#F2F4F7] indent-[35px] h-[48px] !rounded-[8px] text-[#7D8592] font-inter-regular shadow-customsecondary"
                            classes={{ icon: "left-4 !top-[30%]" }}
                            placeholder={t("Search")}
                            onChange={(e) =>
                                setFilterData((prevFormData: any) => ({
                                    ...prevFormData,
                                    search: e.target.value
                                }))
                            }
                            maxLength={20}
                        />
                    </div>
                    <div className="flex flex-row gap-2">
                        <div className="flex-none ">
                            <div className={`relative`}>
                                <FilterBorderedWrapper
                                    className="cursor-pointer h-[48px] w-[48px] "
                                    onClick={() => {
                                        setConfigureTableOpen(!configureTableOpen);
                                    }}
                                >
                                    <Icon iconType={IconType.FILTER_BARS_ICON} />
                                </FilterBorderedWrapper>
                                <ConditionalRender condition={configureTableOpen}>
                                    <DynamicDropdown
                                        setIsOpen={setConfigureTableOpen}
                                        showCloseButton={true}
                                        title={t("Configure Table")}
                                    >
                                        <ConfigureTableDropdown
                                            setCardsOrder={setTableHeaders}
                                            cardsOrder={tableHeaders}
                                        />
                                    </DynamicDropdown>
                                </ConditionalRender>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="relative">
                    {isLoading && <LoadingScreen />}
                    <NoDataBoundary
                        condition={(data as any)?.data?.length > 0}
                        fallback={<EmptyEntity name={t("Questions")} />}
                    >
                        <TeamsTable
                            data={(data as any)?.data ?? []}
                            dataCols={tableHeaders}
                        />
                    </NoDataBoundary>
                </div>
            </DashboardBoxLayout>

            <CreateAndUpdateQuestions
                hocClasses={{
                    modalClassName: "w-full sm:max-w-[900px]"
                }}
                onConfirm={() => {
                    setIsModalOpen(false);
                }}
                hocTitle={'Create New Question'}
                hocCurrentStep={1}
                hocToggleModal={() => { setIsModalOpen(!isModalOpen) }}
                hocisOpen={isModalOpen}
                hocHasChanges={false}
            />

        </div>
    )
}

export default QualityManagement